import "@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js";
import "@webcomponents/custom-elements/custom-elements.min.js";

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { SpsSupportCenter } from '../../../react';
import { register, SpsFileUploadComponent } from "@spscommerce/ds-web-components";

register(SpsFileUploadComponent);

export class SpsSupportCenterRootController {
    public static $inject = [];

    constructor() {
        if (document.getElementById('sps-support-center-root')) {
            ReactDOM.render(
                React.createElement(SpsSupportCenter),
                document.getElementById('sps-support-center-root')
            );
        }
    }
}
